import { Controller } from "@hotwired/stimulus"

/**
 * My Stats live-banner dismiss.
 *
 * Banner is rendered unconditionally on the server; this controller
 * hides it on connect if the session has already dismissed it for
 * the current event, and persists the dismissal when the user clicks
 * the × button. Scope is per-event so a new live event re-shows
 * the banner for the same session.
 */
const STORAGE_KEY = (eventId) => `my_stats_live_banner_dismissed_${eventId}`

export default class extends Controller {
  static values = { eventId: String }

  connect() {
    if (!this.eventIdValue) return
    try {
      if (sessionStorage.getItem(STORAGE_KEY(this.eventIdValue)) === "1") {
        this.element.remove()
      }
    } catch (_e) { /* storage blocked — fall through and keep banner visible */ }
  }

  dismiss() {
    try {
      sessionStorage.setItem(STORAGE_KEY(this.eventIdValue), "1")
    } catch (_e) { /* non-fatal */ }
    this.element.remove()
  }
}
